<template>
    <JetFormSection @submitted="updateSettingUangMakan">
        <template #title>
            Uang Makan
        </template>

        <template #description>
            Setting tarif uang makan
        </template>

        <template #form>
            <!-- Uang Makan Gol 1 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_uang_makan_gol_1" value="Gol 1" />
                <JetInput id="tarif_uang_makan_gol_1" type="text" class="mt-1 block w-full" v-model="form.tarif_uang_makan_gol_1" autocomplete="tarif_uang_makan_gol_1" />
                <JetInputError :message="form.errors.tarif_uang_makan_gol_1" class="mt-2" />
            </div>

            <!-- Uang Makan Gol 2 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_uang_makan_gol_2" value="Gol 2" />
                <JetInput id="tarif_uang_makan_gol_2" type="text" class="mt-1 block w-full" v-model="form.tarif_uang_makan_gol_2" autocomplete="tarif_uang_makan_gol_2" />
                <JetInputError :message="form.errors.tarif_uang_makan_gol_2" class="mt-2" />
            </div>

            <!-- Uang Makan Gol 3 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_uang_makan_gol_3" value="Gol 3" />
                <JetInput id="tarif_uang_makan_gol_3" type="text" class="mt-1 block w-full" v-model="form.tarif_uang_makan_gol_3" autocomplete="tarif_uang_makan_gol_3" />
                <JetInputError :message="form.errors.tarif_uang_makan_gol_3" class="mt-2" />
            </div>

            <!-- Uang Makan Gol 4 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_uang_makan_gol_4" value="Gol 4" />
                <JetInput id="tarif_uang_makan_gol_4" type="text" class="mt-1 block w-full" v-model="form.tarif_uang_makan_gol_4" autocomplete="tarif_uang_makan_gol_4" />
                <JetInputError :message="form.errors.tarif_uang_makan_gol_4" class="mt-2" />
            </div>

            <!-- Uang Makan Gol 0 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_uang_makan_gol_0" value="Tanpa Golongan" />
                <JetInput id="tarif_uang_makan_gol_0" type="text" class="mt-1 block w-full" v-model="form.tarif_uang_makan_gol_0" autocomplete="tarif_uang_makan_gol_0" />
                <JetInputError :message="form.errors.tarif_uang_makan_gol_0" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <InertiaButtonSave :class="{ 'opacity-25': form.processing }" label="Simpan" />
        </template>
    </JetFormSection>
</template>

<script>
    import { defineComponent } from 'vue';
    import JetFormSection from '@/Jetstream/FormSection';
    import JetInput from '@/Jetstream/Input';
    import JetInputError from '@/Jetstream/InputError';
    import JetLabel from '@/Jetstream/Label';
    import InertiaButtonSave from '@/Components/InertiaButtonSave.vue';

    export default defineComponent({
        components: {
            JetFormSection,
            JetInput,
            JetInputError,
            JetLabel,
            InertiaButtonSave,
        },
        data() {
            return {
                form: this.$inertia.form({
                    _method: 'PUT',
                    tarif_uang_makan_gol_0: this.$page.props.setting.tarif_uang_makan_gol_0,
                    tarif_uang_makan_gol_1: this.$page.props.setting.tarif_uang_makan_gol_1,
                    tarif_uang_makan_gol_2: this.$page.props.setting.tarif_uang_makan_gol_2,
                    tarif_uang_makan_gol_3: this.$page.props.setting.tarif_uang_makan_gol_3,
                    tarif_uang_makan_gol_4: this.$page.props.setting.tarif_uang_makan_gol_4,
                }),
            }
        },
        methods: {
            updateSettingUangMakan() {
                this.form.post(route('setting.uangmakan.save'), {
                    errorBag: 'updateSettingUangMakan',
                    preserveScroll: true,
                    // onSuccess: () => (this.clearPhotoFileInput()),
                });
            },
        },
    })
</script>
